var map = {
	"./2025-04-02": "189d",
	"./2025-04-02.yml": "189d",
	"./2025-10-13": "faeb",
	"./2025-10-13.yml": "faeb",
	"./2026-01-18": "bba3",
	"./2026-01-18.yml": "bba3",
	"./2026-01-25": "59d7",
	"./2026-01-25.yml": "59d7",
	"./active": "5448",
	"./active.yml": "5448",
	"./event-2026-05_001_eventguide": "725e",
	"./event-2026-05_001_eventguide.yml": "725e",
	"./event-2026-08-28_001_ticket-sale-announcement": "5725",
	"./event-2026-08-28_001_ticket-sale-announcement.yml": "5725",
	"./event-2026-08-28_002_ticket-sale-reminder": "c034",
	"./event-2026-08-28_002_ticket-sale-reminder.yml": "c034",
	"./events-2027": "3b50",
	"./events-2027.yml": "3b50"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e577";